import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { MotionProvider } from './components/motion.tsx';
import { router } from './router.tsx';
import { connectRealtime } from './realtime.ts';
import { startKeepalive } from './keepalive.ts';
import { installTranslationSafety } from './translation-safety.ts';
import './styles.css';

/*
 * Before React renders anything, because the DOM methods it guards are called
 * during React's own commit. A person reading this application through Chrome's
 * translator is the normal case, not the edge case: the interface is Japanese
 * only.
 */
// The cast bridges lib.dom's Node to this module's two-member view of it: the
// module is written structurally so the unit test can reach it from a project
// that has no DOM at all.
installTranslationSafety(Node.prototype as never);

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

// Live invalidation: the server announces a change, the router refetches it
// through the same authorized loaders. Started once, for the app's lifetime.
connectRealtime(router);

// The session's idle timeout follows the person, not the socket. Without this an
// author typing for an hour issued no requests at all and was signed out
// mid-sentence; see keepalive.ts.
startKeepalive();

createRoot(container).render(
  <StrictMode>
    <MotionProvider>
      <RouterProvider router={router} />
    </MotionProvider>
  </StrictMode>,
);
